<template>
      <template v-if="$route.name === 'GroupSchedule'">

  <ScheduleTable 
    :group-id="groupId"
    :group-name="groupName"
  />
  </template>
  <router-view></router-view>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import ScheduleTable from '@/components/features/schedules/ScheduleTable.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const store = useStore();
const toast = useToast();

const groupId = route.params.groupId;
const classId = route.params.classId;
const groupName = ref('');

const fetchGroupData = async () => {
  try {
    const response = await store.dispatch('groups/fetchGroup', groupId);
    groupName.value = response.data.name;
  } catch (error) {
    toast.error(t('groups.loadError'));
    router.push({ name: 'ClassGroups', params: { classId } });
  }
};

onMounted(() => {
  fetchGroupData();
});
</script>